import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import Section from 'primitives/Section';
import styled from '@emotion/styled';

const SectionRightResults = styled(Section)(({ theme }) => ({
  'li a:hover': {
    textDecoration: 'underline',
  },
  maxWidth: '35rem',
  width: '35rem',
  [mediaQueryBuilder(theme.mediaQueries.max.width['768'])]: {
    marginLeft: '2.5rem',
    maxWidth: '100%',
    paddingRight: '2.5rem',
  },
}));

export default SectionRightResults;
